import styled, { css } from 'styled-components'
import { isNotNullish } from '../utils/type-check'

const Text = styled.div<{letterSpacing?: string}>`
  line-height: 2.6;
  font-weight: 500;
  text-align: center;
  ${({letterSpacing}) => isNotNullish(letterSpacing) && css`
    letter-spacing: ${letterSpacing};
  `}
  @media (max-width: 40rem){
    padding-right: 1rem;
    padding-left: 1rem;
  }
  & + & {
    margin-top: 1rem;
  }
`

export const SectionTextExtraLarge = styled(Text)`
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  @media (max-width: 40rem){
    font-size: 1.75rem;
    line-height: 1.5;
  }
`
export const SectionTextLarge = styled(Text)`
  font-size: 1.5rem;
  font-weight: 700;
  @media (max-width: 40rem){
    font-size: 1.25rem;
    line-height: 1.5;
  }
`
export const SectionTextMedium = styled(Text)`
  font-size: 1rem;
`
export const SectionTextSmall = styled(Text)`
  font-size: 1rem;
  @media (max-width: 40rem){
    text-align: left;
  }
  br {
    @media (max-width: 40rem){
      display: none;
    }
  }
`
export const SectionTextExtraSmall = styled(Text)`
  font-size: 0.8rem;
`